(() => {
  if (customElements.get('b4a-product-help')) return;

  function findActivator(root) {
    const button = root.querySelector('button.activator');
    if (button) return button;
    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const nested = findActivator(element.shadowRoot);
        if (nested) return nested;
      }
    }
    return null;
  }

  customElements.define('b4a-product-help', class extends HTMLElement {
    connectedCallback() {
      this.owner = this.closest('.product--outer');
      this.email = this.querySelector('[data-b4a-help-email]');
      this.chat = this.querySelector('[data-b4a-help-chat]');
      this.status = this.querySelector('[role="status"]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const sectionData = this.closest('.shopify-section')?.querySelector('script[data-section-data]');
      try { this.variants = JSON.parse(sectionData?.textContent || '{}').product?.variants || []; }
      catch { this.variants = []; }
      this.updateEmail();
      this.email.addEventListener('click', () => this.updateEmail(), options);
      this.email.addEventListener('focus', () => this.updateEmail(), options);
      this.email.addEventListener('pointerenter', () => this.updateEmail(), options);
      this.owner?.addEventListener('change', () => this.queueUpdate(), { ...options, capture: true });
      this.observer = new MutationObserver(() => this.queueUpdate());
      if (this.owner) this.observer.observe(this.owner, {
        attributes: true, subtree: true, attributeFilter: ['variant', 'value', 'selected']
      });
      this.chat.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.openChat();
      }, options);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.updateFrame);
      clearTimeout(this.chatTimer);
    }

    queueUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.updateEmail());
    }

    updateEmail() {
      const selection = this.owner?.querySelector('[data-product-form] variant-selection');
      const field = selection?.querySelector('[name="id"]');
      const id = field?.value || selection?.getAttribute('variant') || this.dataset.initialVariant;
      const variant = this.variants.find(item => String(item.id) === String(id));
      const sku = variant ? (variant.sku || '') : this.dataset.initialSku;
      const subject = this.dataset.subjectTemplate.replace('__SKU__', sku || '');
      this.email.href = 'mailto:info@bath4all.com?subject=' + encodeURIComponent(subject);
    }

    openChat() {
      if (this.chat.getAttribute('aria-busy') === 'true') return;
      this.chat.setAttribute('aria-busy', 'true');
      this.status.hidden = true;
      let attempts = 0;
      const attempt = () => {
        const host = document.querySelector('shopify-chat');
        const activator = host ? findActivator(host.shadowRoot || host) : null;
        if (activator) {
          if (!host.hasAttribute('open') && activator.getAttribute('aria-expanded') !== 'true') activator.click();
          this.chat.removeAttribute('aria-busy');
          return;
        }
        if (++attempts < 40 && this.isConnected) {
          this.chatTimer = setTimeout(attempt, 250);
        } else {
          this.chat.removeAttribute('aria-busy');
          this.status.hidden = false;
        }
      };
      this.chatTimer = setTimeout(attempt, 100);
    }
  });
})();
